// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.18.2
import { getDecoderStateCallbacks, Reflection, Decoder } from '@colyseus/schema';

//
// TODO: use a schema interface, which even having duplicate definitions, it could be used to get the callback proxy.
//
// ```ts
//     export type SchemaCallbackProxy<RoomState> = (<T extends ISchema>(instance: T) => CallbackProxy<T>);
//     export function getStateCallbacks<T extends ISchema>(room: Room<T>) {
// ```
//
function getStateCallbacks(room) {
    try {
        // SchemaSerializer
        // @ts-ignore
        return getDecoderStateCallbacks(room['serializer'].decoder);
    }
    catch (e) {
        // NoneSerializer
        return undefined;
    }
}
class SchemaSerializer {
    state;
    decoder;
    setState(encodedState, it) {
        // A full snapshot is authoritative: on a rejoin (decoder already
        // holds refs beyond the root) reconcile — entries the snapshot
        // doesn't contain were deleted/hidden while this client was off the
        // wire. A first join decodes onto a fresh tree — nothing to
        // reconcile, skip the bookkeeping (measured +10-25% on large
        // states). Patches stay additive. Older @colyseus/schema
        // resolutions lack decodeResync — degrade to the additive decode.
        if (this.decoder.root.refs.size > 1 && typeof this.decoder.decodeResync === "function") {
            this.decoder.decodeResync(encodedState, it);
        }
        else {
            this.decoder.decode(encodedState, it);
        }
    }
    getState() {
        return this.state;
    }
    patch(patches, it) {
        return this.decoder.decode(patches, it);
    }
    teardown() {
        this.decoder.root.clearRefs();
    }
    handshake(bytes, it) {
        if (this.state) {
            //
            // TODO: validate definitions against concreate this.state instance
            //
            Reflection.decode(bytes, it); // no-op
            this.decoder = new Decoder(this.state);
        }
        else {
            // initialize reflected state from server
            this.decoder = Reflection.decode(bytes, it);
            this.state = this.decoder.state;
        }
    }
}

export { SchemaSerializer, getStateCallbacks };
//# sourceMappingURL=SchemaSerializer.mjs.map
